<template>
  <PopupModal :open="true" has-close-button @close="close">
    <template #body>
      <h1 class="textHeadline3" v-html="text"></h1>
    </template>
    <template #footer>
      <div class="flex flex-row justify-center">
        <BaseButton
          class="mt-4 w-44 text-center mx-auto"
          variant="primary"
          @click="close"
        >
          {{ $t("web.error.platform.button") }}
        </BaseButton>
      </div>
    </template>
  </PopupModal>
</template>

<script>
import PopupModal from "../layout/PopupModal.vue";
import BaseButton from "~/components/v2/layout/button/BaseButton.vue";

export default {
  name: "DesktopVersionDeactivatedModal",
  components: {
    BaseButton,
    PopupModal,
  },
  props: {
    open: Boolean,
    text: String,
  },
  emits: ["close"],
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
